<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center;display: flex;"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="margin: 10px auto; text-align: center">
                        Queue Service Request Form - Administrator
                      </h3>
                    </div>

                    <form class="wpcf7-form" @submit.prevent="submit" v-if="generatedLink == null">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Username</label>
                        <input
                          v-model="username"
                          type="text"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          placeholder="Enter Username"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Password</label>
                        <input
                          v-model="password"
                          type="password"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          placeholder="Enter Password"
                          required=""
                        />
                      </div>
                      <div class="error" v-if="allFieldsRequiredError">
                        <p
                          style="font-size: 14px; color: red; font-weight: bold"
                        >
                          Please fill all details!
                        </p>
                      </div>
                      <div class="error" v-if="emailFormatError">
                        <p
                          style="font-size: 14px; color: red; font-weight: bold"
                        >
                          Invalid email address format!
                        </p>
                      </div>
                      <button
                        type="button"
                        class="btn btn-primary check-btn"
                        v-on:click="goNext"
                        style="display: block;margin: 0 auto;"
                      >
                        Generate QSRF Link
                      </button>
                    </form>

                    <div v-if="generatedLink !== null">
                      <a style="padding: 30px;text-align: center;width: 100%;display: block;margin: 30px 0;background: #6773dd;color: #fff;font-size: 30px;border-radius: 50px;" v-bind:href="generatedLink" target="_blank">{{generatedLink}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";

export default {
  name: "support_track",
  data() {
    return {
      msg: "Clear Me Out - Support",
      packageSelection: "general",
      firstName: "",
      lastName: "",
      email: "",
      mobileNumber: "",
      mobileNumberCode: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      zipCode: "",
      city: "",
      allFieldsRequiredError: false,
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      emailError: false,
      dateOfBirth: new Date(),
      country: "Sri Lanka",
      refId: null,
      loading: true,
      isExpired: false,
      emailFormatError: false,
      username: "",
      password: "",
      generatedLink: null,
    };
  },
  components: {
    datetime: Datetime,
  },
  methods: {
    onSelect: function (d) {
      this.mobileNumberCode = d.dialCode;
    },
    goNext: function (d) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.allFieldsRequiredError = false;
      this.emailFormatError = false;

      const $this = this;

      if (
        this.username == "" ||
        this.password == ""
      ) {
        this.allFieldsRequiredError = true;
        return;
      }

      if (!re.test(String(this.username).toLowerCase())) {
        this.emailFormatError = true;
        return;
      }

      $.post("https://stagingapi.clearmeout.com/api/auth/login", {
        email: this.username,
        password: this.password,
      }).done(function (data) {
        if (data.data && data.data.authorization) {
          $.ajax({
            url:
              "https://stagingapi.clearmeout.com/api/user/generateLink",
            data: {},
            type: "GET",
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", data.data.authorization);
              xhr.setRequestHeader("Content-Type", "application/json");
            },
            success: function (data) {
              if(data.data && Object.keys(data.data).indexOf("requestId") > -1) {
                $this.generatedLink = `https://qsrf.clearmeout.com/${data.data.requestId}`;
              } else {
                $this.generatedLink = null;
              }

              $this.loading = false;
            },
          });
        }
      });
    },
    onAddClientInputLegalDocs: function (d) {
      if (this.clientInputLegalDocs.length > this.clientInputLegalDocsLimit) {
        return;
      }
      this.clientInputLegalDocs.push({ file: "" });
    },
    onAddClientInputSignature: function (d) {
      if (this.clientInputSignature.length > this.clientInputSignatureLimit) {
        return;
      }
      this.clientInputSignature.push({ file: "" });
    },
    onChangeClientInputLegalDocs: function (item, index) {
      if (
        item &&
        item.target &&
        item.target.files &&
        Array.isArray(item.target.files)
      ) {
        this.clientInputLegalDocs[index].file = item.target.files[0];
      } else {
        this.clientInputLegalDocs[index].file = null;
      }
    },
    onChangeClientInputSignatureDocs: function (item, index) {
      if (
        item &&
        item.target &&
        item.target.files &&
        Array.isArray(item.target.files)
      ) {
        this.clientInputSignature[index].file = item.target.files[0];
      } else {
        this.clientInputSignature[index].file = null;
      }
    },
    onSelectCountry: function (d) {
      this.country = d.name;
    },
    submit: function (e) {
      // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const $this = this;
      // this.emailRequiredError = false;
      // this.ticketNumberRequiredError = false;
      // this.emailError = false;
      // jQuery
      //   .post("http://stagingportal.clearmeout.com/signup.php")
      //   .done(function (data) {
      //     $this.email = "";
      //     $this.ticketNumber = "";
      //     if (data.status == 500) {
      //       $this.$toast.open({
      //         message: data.status_message,
      //         type: "error",
      //       });
      //     }
      //   })
      //   .fail(function (data) {
      //     $this.$toast.open({
      //       message:
      //         "Invalid registration details. Please update and submit again.",
      //       type: "error",
      //     });
      //   });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue